// Controlled via Railway → web service → Variables. No code change needed when new data arrives.
//
// Current state:  ALLOTMENT_YEAR=2025, CUTOFF_START_YEAR=2020, CUTOFF_END_YEAR=2024
// After 2025 cutoffs imported: set CUTOFF_START_YEAR=2021, CUTOFF_END_YEAR=2025 (keeps 5-year window)

export const ALLOTMENT_YEAR: number =
  Number(import.meta.env.VITE_ALLOTMENT_YEAR) || 2025;

export const CUTOFF_END_YEAR: number =
  Number(import.meta.env.VITE_CUTOFF_END_YEAR) || 2025;

// Always 5 years ending at CUTOFF_END_YEAR unless explicitly overridden
export const CUTOFF_START_YEAR: number =
  Number(import.meta.env.VITE_CUTOFF_START_YEAR) || CUTOFF_END_YEAR - 4;
